/**
 * /me/leaves/request — Session 3d PR 2.
 * Owning agent: Khidmat. Detail-card-style page (NOT a list).
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { ErrorPanel, Loading } from "../components/Loading";
import { session3dApi } from "../lib/session3d-api";
import {
  MeActionsRow,
  MeEmployeeRequiredGate,
  Session3dMeShell,
  useCurrentEmployeeId,
} from "./_session3dShell";

export function MyRequestLeavePage() {
  const { t } = useTranslation();
  const employeeId = useCurrentEmployeeId();

  const query = useQuery({
    queryKey: ["s3d-request-leave", employeeId],
    queryFn: () => session3dApi.listMyLeaveBalances(employeeId),
    enabled: !!employeeId,
  });

  const data = query.data;

  return (
    <MeEmployeeRequiredGate>
      <Session3dMeShell
        title={t("me.request-leave.title", "Request New Leave")}
        subtitle={t("me.request-leave.subtitle", "Submit a leave request as workflow draft → routes through M15.5 approval chain.")}
        briefContext={{
          total: 1,
          attention: 0,
          critical: 0,
          top_kind: t("me.request-leave.title", "Request New Leave"),
          window_label: t("me.request-leave.window", "your eligible types"),
        }}
        actionsRow={
          <MeActionsRow
            khidmatPrefill={t("me.request-leave.ask_khidmat", "Help me draft a leave request.")}
          />
        }
      >
        {query.isLoading && <Loading />}
        {query.isError && <ErrorPanel message={(query.error as Error).message} />}
        {data && (
          <div className="rounded-2xl border border-border-subtle bg-white p-4 text-sm">
            <p className="text-xs text-text-tertiary">
              {t(
                "me.request-leave.detail_note",
                "Form fields: leave_type · start/end dates · days requested · reason · attachment (if required). Submit creates leave_request in 'draft' → submits → M15.5 chain. The form drawer wires with M3X.WORKFLOW pack.",
              )}
            </p>
            <pre className="mt-3 overflow-x-auto rounded bg-surface-sunken p-3 font-mono text-[10px] text-text-secondary">
{JSON.stringify(data, null, 2)}
            </pre>
          </div>
        )}
      </Session3dMeShell>
    </MeEmployeeRequiredGate>
  );
}
